import { BaseContextType } from '@smx-ui-model/types';

import { sharingDocumentCoreModel } from './sharing-document-core-model';
import { SharingDocumentModelSchemaType } from './types';

export const sharingDocumentModel: SharingDocumentModelSchemaType<BaseContextType> = {
    ...sharingDocumentCoreModel,
    renderData: {},
    action: {},
};
